import './build/mapboxgl/shared';
import './build/mapboxgl/worker';
import './build/mapboxgl/index';

export default mapboxgl;
